<template>
  <div class="flex gap-4">
    <VerticalProgressBar
      width-class="w-1"
      progress-bg-class="bg-fp-green-6"
      remaining-progress-bg-class="bg-fp-green-7"
      :percentage-progressed="percentageOfBarToFill"
    />
    <div class="flex flex-col gap-12">
      <div v-for="step in steps" :key="step">
        <div
          :class="{
            'text-sm': true,
            flex: true,
            'flex-col': true,
            'p-4': true,
            'bg-fp-green-7 rounded-md': step === currentStep,
            'text-fp-gray-4': step !== currentStep,
            'text-fp-green-0': step === currentStep,
          }"
        >
          <span class="text-fp-green-0">Step {{ stepIndex(step) }}</span>
          <span>{{ step }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import VerticalProgressBar from './VerticalProgressBar.vue'

const props = defineProps<{
  currentStep: string
  steps: string[]
}>()

const stepIndex = (step: string) => {
  return props.steps.indexOf(step) + 1
}

const currentStepIndex = computed(() => {
  return stepIndex(props.currentStep)
})

const percentageOfBarToFill = computed(() => {
  // The percentage correspondent to the percentage of the first step
  const offsetPercentage = 7
  // The percentage correspondent to the distance between first step and last step
  const percentageLengthFirstToLast = 100 - offsetPercentage * 2

  return Math.round(
    ((currentStepIndex.value - 1) / (props.steps.length - 1)) *
      percentageLengthFirstToLast +
      offsetPercentage
  )
})
</script>

<style scoped></style>
